export default __webpack_public_path__ + "static/media/toolbox.ddba7a0e.png";